var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C30.2 0 28 2 28 4H12C12 2 9.8 0 8 0H0V18C0 20 2 22 4 22H8.4C9.2 26 11.8 29.4 18 30V34.16C12 35.08 12 40 12 40H28C28 40 28 35.08 22 34.16V30C28.2 29.4 30.8 26 31.6 22H36C38 22 40 20 40 18V0H32ZM8 18H4V4H8V18ZM28 19C28 22.86 26.84 26 20 26C13.18 26 12 22.86 12 19V8H28V19ZM36 18H32V4H36V18Z",
    fill: "#85B6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellence);
export default __webpack_public_path__ + "static/media/Excellence.a276d72f079360ac99ab291e8405f509.svg";
export { ForwardRef as ReactComponent };